export default "__VITE_ASSET__7af8ec68__"